import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-194" data-mp="1223hv7d79009">
      <div className="mx-auto max-w-3xl" data-id="element-195" data-mp="122vdujapkzr2">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand" data-id="element-196" data-mp="1pro1ztl3a3b4">Frequently asked questions</p>
        <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-197" data-mp="1uq94jzntcz2q">Everything you need to know before purchasing</h2>
        <ul className="mt-10 space-y-3" data-id="element-198" data-mp="1l1hexy686quz">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="rounded-2xl bg-white" data-id="element-199" data-mp="28q0oeh10h9on" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand rounded-2xl" data-id="element-200" data-mp="2dhs5m0ya2324">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-201" data-mp="2ygtow56f97rz">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-cta" : "bg-sky"}`} data-id="element-202" data-mp="2tojuabud3jjd">
                    <PlusIcon className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-203" data-mp="32h3wfm9v468y" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-204" data-mp="3hctj7mmvgneq">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-205" data-mp="3cgkyzutti40p">
                      <div className="space-y-3 px-5 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-206" data-mp="2bqrbw13dgyma">
                        {f.a.map(p => <p key={p} data-id="element-207" data-mp="2gsp0zbygenn5">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <SectionCta heading="All your questions answered? Get started today" label="Get my Blueprint for $27" note="One-time payment · Digital collection · No recurring subscription" data-id="element-208" data-mp="2uq552gta25bq" />
      </div>
    </section>;
}